import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.css";
import "../../App/App.css";
import "../../assets/style.css";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar.jsx";
import { adminLogin, adminStatus } from "../../lib/services/authService.js";
import { useEffect } from "react";

/**
 * Admin Login page
 */
const Login = ({ isAdminAuthenticated, setIsAdminAuthenticated }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  useEffect(() => {
    const checkAdminStatus = async () => {
      const response = await adminStatus();
      if (response.ok) {
        const data = await response.json();
        setIsAdminAuthenticated(data.isAuthenticated);
      }
    };

    checkAdminStatus();
  }, []);

  useEffect(() => {
    if (!!isAdminAuthenticated) navigate("/admin/stencil-selection");
  }, [isAdminAuthenticated, navigate]);

  // Users need to input admin password
  async function login(data) {
    const response = await adminLogin(data);

    if (response.ok) {
      setIsAdminAuthenticated(true);
    } else {
      alert("Login failed");
    }
  }

  return (
    <div style={{overflow: 'hidden'}}>
      <Navbar
        isAdminAuthenticated={isAdminAuthenticated}
        setIsAdminAuthenticated={setIsAdminAuthenticated}
        location={"/admin/login"}
      />
      <div className="container mt-5" style={{paddingTop : '150px'}}>
        <div className="row">
          <div className="col-md-6 mx-auto mt-5">
            <h1 className="text-center">Admin Log In</h1>
            <form
              className="mt-5"
              style={{ textAlign: "center" }}
              onSubmit={handleSubmit(login)}
            >
              <input
                {...register("password", { required: true })}
                className="text-field"
                type="password"
                placeholder="Password"
              />
              {errors.password && (
                <p className="text-danger">Password required.</p>
              )}{" "}
              <br />
              <button
                type="submit"
                className="submit-button mt-2"
                style={{ padding: "5px" }}
              >
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
